import type { CaeListItem } from "@/services/invoiceService";

export const CERTIFICATE_GUIDE_VISITED_KEY = "onboarding.certificateGuide.visited";
/**
 * Re-exported from shared-utils so the portal and the backend cannot drift.
 * The old local value was "literal_e_proof"; the server normalized it to
 * "literal-e-proof" on write, so the stored rows have always used the kebab
 * form and the canonical constant is that one.
 */
export { LITERAL_E_PROOF_DOCUMENT_NAME } from "@fiscalo/shared-utils";

/**
 * Onboarding requires at least one active (non-deleted) CAE per type (DGI codes):
 * e-Ticket, e-Ticket nota de crédito, e-Factura, e-Factura nota de crédito.
 */
export const REQUIRED_ONBOARDING_CAE_CFE_TYPES = [
  "101",
  "102",
  "111",
  "112",
] as const;

export function getMissingRequiredOnboardingCaeCfeTypes(
  caeList: CaeListItem[] | undefined
): string[] {
  if (!caeList?.length) {
    return [...REQUIRED_ONBOARDING_CAE_CFE_TYPES];
  }
  const activeTypes = new Set(
    caeList
      .filter((c) => !c.deletedAt)
      .map((c) => String(c.cfeType).trim())
  );
  return REQUIRED_ONBOARDING_CAE_CFE_TYPES.filter((t) => !activeTypes.has(t));
}
